var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 89.5,
    r: 89.5,
    fill: "#E26824"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.051 63.4552C129.111 60.379 129.111 55.3833 126.051 52.3071C122.991 49.231 118.021 49.231 114.962 52.3071L89.185 78.2454L63.384 52.3317C60.3241 49.2556 55.3548 49.2556 52.2949 52.3317C49.235 55.4079 49.235 60.4036 52.2949 63.4798L78.096 89.3935L52.3194 115.332C49.2595 118.408 49.2595 123.404 52.3194 126.48C55.3793 129.556 60.3486 129.556 63.4085 126.48L89.185 100.542L114.986 126.455C118.046 129.531 123.015 129.531 126.075 126.455C129.135 123.379 129.135 118.383 126.075 115.307L100.274 89.3935L126.051 63.4552Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.16324bdb3aed5f78c60e4f66b10dd86c.svg";
export { ForwardRef as ReactComponent };